/*
Smartbrush Checkout
*/

class SmartbrushCheckout extends HTMLElement {
  connectedCallback() {
    const subOptions = this.querySelectorAll(".sub-option");
    const first_sub = subOptions[1];
    this.variantId = first_sub.dataset.variantId;
    this.monthlyPlanId = first_sub.dataset.monthlyPlanId;
    this.monthlyPlanVariantId = first_sub.dataset.monthlyPlanVariantId;

    this.setupContinueWithoutSub();
    this.setupContinueWithSub();
    this.setupSubOptions();
  }

  setupContinueWithoutSub() {
    this.querySelector(".continue-without-sub").addEventListener(
      "click",
      async (e) => {
        e.preventDefault();

        const button = e.target;

        button.setAttribute("disabled", true);
        button.innerHTML = "Continuing...";

        const siteCart = document.querySelector("site-cart");
        const quantity = document
          .querySelector("product-quantity-selector span")
          .textContent.trim();

        await siteCart.addVariantToCart(this.variantId, quantity, null, false);

        window.location.href = "/checkout";
      }
    );
  }

  setupContinueWithSub() {
    this.querySelector(".continue-with-sub").addEventListener(
      "click",
      async (e) => {
        e.preventDefault();

        const button = e.target;

        button.setAttribute("disabled", true);
        button.innerHTML = "Adding...";

        const siteCart = document.querySelector("site-cart");
        const quantity = document
          .querySelector("product-quantity-selector span")
          .textContent.trim();

        await siteCart.addVariantToCartWithSubscription(
          this.monthlyPlanVariantId,
          quantity,
          this.monthlyPlanId,
          false
        );
        await siteCart.addVariantToCart(this.variantId, quantity, null, false);

        window.location.href = "/checkout";
      }
    );
  }

  setupSubOptions() {
    this.querySelectorAll(".sub-option").forEach((option) => {
      option.addEventListener("click", (e) => {
        this.querySelectorAll(".sub-option").forEach((option) =>
          option.classList.remove("active")
        );
        const button = e.target.closest("button");
        if (button) {
          button.classList.add("active");
          this.variantId = button.dataset.variantId;
          this.monthlyPlanId = button.dataset.monthlyPlanId;
          this.monthlyPlanVariantId = button.dataset.monthlyPlanVariantId;
        }
      });
    });
  }
}

customElements.define("smartbrush-checkout", SmartbrushCheckout);
